
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import MaterialTable from 'material-table';
import{ SERVER_PATH, AXIOS_CONFIG } from '../common/redux/constantes';
import SelectionForm from './SelectionForm';
import moment from 'moment';
import DownloadCsv from "../common/DownloadCsv";

// import ExpansionPanel from '@material-ui/core/ExpansionPanel';
// import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
// import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
// import ExpandMoreIcon from '@material-ui/icons/ExpandMore';


class Status extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
  };
  state ={
    costs:[],
    openDeleteAlert:false,
    deleteCostID:-1,
    selected_reporting_period:-1,
    selected_control_account:-1,
    //tableToDownload:1, //1- ProjectPerformance, 2- ProjectEarnedScheduled
  }

  constructor(props) {
    super(props);
    this.tableRef = React.createRef();
    this.tableRef2 = React.createRef();
    //bindings
    this.changeForm = this.changeForm.bind(this);
    this.setDownloadInfo=this.setDownloadInfo.bind(this)
    this.setDownloadInfo1=this.setDownloadInfo1.bind(this)
  }
  
  setDownloadInfo=(info)=>
  {
    let value={ data:JSON.parse(JSON.stringify(info)), 
             headers:[
             {label:"Reporting Period (RP)", key:"reporting_number"},
             {label:"Planned Value (PV)", key:"planned_value"},
             {label:"Earned Value (EV)", key:"earned_value"},
             {label:"Actual Costo (AC)", key:"actual_cost"},
             {label:"SV", key:"calc_sv"},
             {label:"CV", key:"calc_cv"},
             {label:"SPI", key:"calc_spi"},
             {label:"CPI", key:"calc_cpi"},
             {label:"BAC", key:"calc_bac"},
             {label:"EAC", key:"calc_eac"},
             {label:"VAC", key:"calc_vac"},
             {label:"TCPI", key:"calc_tcpi"},
             {label:"Margin", key:"margin"},
             {label:"(%)", key:"calc_complete"},

             ],
             tableName:"ProjectPerformance", 
             type:7
           }
     this.setState({
       tableData:value
     })
   }
  setDownloadInfo1=(info)=>{
    let value={ data:JSON.parse(JSON.stringify(info)), 
      headers:[
      {label:"Reporting Period (RP)", key:"reporting_number"},
      {label:"ES", key:"calc_es"},
      {label:"SVt", key:"calc_svt"},
      {label:"SPIt", key:"calc_spit"},
      {label:"EACt", key:"calc_eact"},
      {label:"EACt (date)", key:"calc_end_date"},
      ],
      tableName:"ProjectEarnSchedule", 
      type:7
    }
    this.setState({
      tableData1:value
    })
  }

  changeForm(reporting_period, control_account)
  {
    this.setState({selected_reporting_period:reporting_period, selected_control_account:control_account});
    this.refreshTable();
  }  

  refreshTable=()=>
  {
    this.tableRef.current && this.tableRef.current.onQueryChange();
    this.tableRef2.current && this.tableRef2.current.onQueryChange();
  }


  
  render() {

      return (
        <div >
        
          <SelectionForm project={this.props.project} changeForm={this.changeForm}/>
          









          <MaterialTable
            tableRef={this.tableRef2}
            onRowClick={((evt, selectedRow) => this.setState({ selectedRow }))}
            style={{minWidth:"100% !important"}}
            actions={[
              {
                icon: 'save',
                tooltip: 'Save Data',
                isFreeAction: true,
                onClick: () => 
                {
                  this.childref.downloadData() 
                }
              }
            ]}
            options={{
              actionsColumnIndex:7,
              paging:false,
              search:false,
              sorting:false,
              maxBodyHeight:"300px",
              headerStyle: {
                backgroundColor: '#FFF',
                color: '#000',
                fontSize:'1.05em'
              },
              rowStyle: (rowData) => {
                  return {
                  backgroundColor: 
                      (this.state.selectedRow && this.state.selectedRow.tableData.id === rowData.tableData.id) ? 
                      '#EEE' 
                      :(rowData.tableData.id%2)?"#fff":"#f9f9fa"
                  }
              }
            }}
            title="Project Performance"
            columns={[
              { 
                title: 'RP', 
                field: 'reporting_number',
                cellStyle: {
                  borderRight: "1px solid #d4d4d4"
                }
              },
              { 
                title: 'PV', 
                field: 'planned_value',
                cellStyle: {
                  borderRight: "1px solid #d4d4d4"
                }
              },
              { 
                title: 'EV', 
                field: 'earned_value',
                cellStyle: {
                  borderRight: "1px solid #d4d4d4"
                }
              },
              { 
                title: 'AC', 
                field: 'actual_cost',
                cellStyle: {
                  borderRight: "1px solid #d4d4d4"
                }
              },
              { 
                title: 'SV', 
                field: 'calc_sv',
                cellStyle: {
                  borderRight: "1px solid #d4d4d4"
                }
              },
              { 
                title: 'CV', 
                field: 'calc_cv',
                cellStyle: {
                  borderRight: "1px solid #d4d4d4"
                }
              },
              { 
                title: 'SPI', 
                field: 'calc_spi',
                cellStyle: {
                  borderRight: "1px solid #d4d4d4"
                }
              },
              { 
                title: 'CPI', 
                field: 'calc_cpi',
                cellStyle: {
                  borderRight: "1px solid #d4d4d4"
                }
              },
              { 
                title: 'BAC', 
                field: 'calc_bac',
                cellStyle: {
                  borderRight: "1px solid #d4d4d4"
                }
              },
              { 
                title: 'EAC', 
                field: 'calc_eac',
                cellStyle: {
                  borderRight: "1px solid #d4d4d4"
                }
              },
              { 
                title: 'VAC', 
                field: 'calc_vac',
                cellStyle: {
                  borderRight: "1px solid #d4d4d4"
                }
              },
              { 
                title: 'TCPI', 
                field: 'calc_tcpi',
                cellStyle: {
                  borderRight: "1px solid #d4d4d4"
                }
              },
              { 
                title: 'margin', 
                field: 'margin',
                cellStyle: {
                  borderRight: "1px solid #d4d4d4"
                }
              },
              { 
                title: '%', 
                field: 'calc_complete',
                cellStyle: {
                  borderRight: "1px solid #d4d4d4"
                }
              },
            ]}
          data={query =>
            new Promise((resolve, reject) => {
              let url =SERVER_PATH + '/projects/CaInRps/' + this.props.project;
              fetch(url,AXIOS_CONFIG())
                .then(response => response.json())
                .then(result => {
                  let formatter = null;
                  if (typeof Intl === 'object' && typeof Intl.NumberFormat === 'function') 
                  {
                    formatter = new Intl.NumberFormat('gt-GT', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits:2
                    });
                  }
                  
                  let BAC = 0;
                  let reporting_number = 1; //Primer reporting number siempre!
                  let rp_status = 1; //Estado del rp
                  let temp_result = [];
                  let planned_value = 0;
                  let earned_value = 0;
                  let actual_cost = 0;
                  result.rps.map(o => {
                    if(o.reporting_number !== reporting_number)
                    {
                      temp_result.push({
                        reporting_number:reporting_number,
                        planned_value:planned_value,
                        earned_value:earned_value,
                        actual_cost:actual_cost,
                        rp_status:rp_status
                      });
                      //SE COMENTO DEBIDO A QUE SON LOS CUMULATIVE LOS QUE SE QUIEREN...POR LO QUE AHORA YA NO SE REINICIAN A 0
                      // actual_cost       =0;
                      // planned_value     =0;
                      // earned_value      =0;
                      reporting_number  =o.reporting_number;
                    }
                    if(this.state.selected_control_account > 0 && o.control_account !== this.state.selected_control_account)
                    {
                      //DO NOTHING
                    }else
                    {
                      //Filtrando
                      actual_cost += o.actual_cost;
                      planned_value += o.planned_value;
                      earned_value += o.earned_value;
                      BAC += o.planned_value;
                    }
                    rp_status = o.rp_status;
                    return o;
                  });
                  //Ultimo push
                  temp_result.push({
                    reporting_number:reporting_number,
                    planned_value:planned_value,
                    earned_value:earned_value,
                    actual_cost:actual_cost,
                    rp_status:rp_status
                  });

                  
                  result.rps = temp_result;


                
                  result.rps = result.rps.map(o => {
                    // if(o.planned_value > 0 && o.earned_value > 0 && o.actual_cost>0)
                    if(true)
                    {
                      //SV = EARNED - PLANNED
                      o.calc_sv = o.earned_value - o.planned_value;
                      o.calc_sv = o.calc_sv.toFixed(3);
                      o.calc_cv = o.earned_value - o.actual_cost;
                      o.calc_cv = o.calc_cv.toFixed(3);
                      o.calc_spi = o.earned_value / o.planned_value;
                      o.calc_spi = o.calc_spi.toFixed(3);
                      o.calc_cpi = o.earned_value / o.actual_cost;
                      o.calc_cpi = o.calc_cpi.toFixed(3);
                      if(!isFinite(o.calc_cpi))
                        o.calc_cpi = 1;
                      o.calc_bac = BAC; //Consultar toda la suma de costos planeados

                      let temp1 = o.actual_cost + ((o.calc_bac-o.earned_value) / (o.calc_cpi * o.calc_spi));
                      let temp2 = o.calc_bac / o.calc_cpi;
                      //EAC = Average(temp1:temp2) 
                      o.calc_eac = (temp1 + temp2) / 2;

                      o.calc_eac = o.calc_eac.toFixed(3);
                      o.calc_vac = o.calc_bac - o.calc_eac;
                      o.calc_vac = o.calc_vac.toFixed(3);
                      o.calc_tcpi = (o.calc_bac - o.earned_value) / (o.calc_bac - o.actual_cost);
                      o.calc_complete = (o.earned_value * 100)/ o.calc_bac;
                      o.margin = o.calc_bac - o.actual_cost;
                      o.calc_complete = o.calc_complete.toFixed(0);

                      //Formato
                      if (typeof Intl === 'object' && typeof Intl.NumberFormat === 'function') 
                      {

                        o.calc_sv = isNaN(o.calc_sv) || !isFinite(o.calc_sv)?"-":formatter.format(o.calc_sv);
                        o.calc_spi = isNaN(o.calc_spi) || !isFinite(o.calc_spi)?"-":formatter.format(o.calc_spi);
                        o.calc_cpi = isNaN(o.calc_cpi) || !isFinite(o.calc_cpi)?"-":formatter.format(o.calc_cpi);
                        o.calc_bac = isNaN(o.calc_bac) || !isFinite(o.calc_bac)?"-":formatter.format(o.calc_bac);
                        o.calc_eac = isNaN(o.calc_eac) || !isFinite(o.calc_eac)?"-":formatter.format(o.calc_eac);
                        o.calc_vac = isNaN(o.calc_vac) || !isFinite(o.calc_vac)?"-":formatter.format(o.calc_vac);
                        o.calc_tcpi = isNaN(o.calc_tcpi) || !isFinite(o.calc_tcpi)?"-":formatter.format(o.calc_tcpi);
                        o.margin = isNaN(o.margin) || !isFinite(o.margin)?"-":formatter.format(o.margin);
                        o.calc_complete = isNaN(o.calc_complete) || !isFinite(o.calc_complete)?"-":o.calc_complete;

                        o.planned_value = formatter.format(o.planned_value);
                        o.earned_value = formatter.format(o.earned_value);
                        o.actual_cost = formatter.format(o.actual_cost);
                        o.calc_cv = formatter.format(o.calc_cv);
                        // o.calc_bac = formatter.format(o.calc_bac); 
                        // o.margin = formatter.format(o.margin); 
                        // o.calc_sv = formatter.format(o.calc_sv);
                        // o.calc_spi = formatter.format(o.calc_spi);
                        // o.calc_cpi = formatter.format(o.calc_cpi);
                        // o.calc_eac = formatter.format(o.calc_eac);
                        // o.calc_vac = formatter.format(o.calc_vac);
                        // o.calc_tcpi = formatter.format(o.calc_tcpi);
                        // o.calc_complete = formatter.format(o.calc_complete);
                        //Verificando numeros..
                      }
                    }else
                    {
                      o.calc_eac = "No Data";
                      o.calc_vac = "No Data";
                      o.calc_tcpi = "No Data";
                      o.margin = "No Data";
                      o.calc_complete = "No Data";

                    }
                    return o;
                  });



                  //PRODUCTO 5 ERROR #4
                  // let last_reporting = result.rps[result.rps.length - 1];
                  // last_reporting.calc_sv = "";
                  // last_reporting.calc_cv = "";
                  // last_reporting.calc_spi = "";
                  // last_reporting.calc_cpi = "";
                  // last_reporting.calc_bac = ""; 
                  // last_reporting.calc_eac = "";
                  // last_reporting.calc_vac = "";
                  // last_reporting.calc_tcpi = "";
                  // last_reporting.margin = "";
                  // last_reporting.calc_complete = "";
                  
                  result.rps = result.rps.filter(obj => {
                      //Filtrando por reporting_number y el estado sea completado
                      let rp_filter = this.state.selected_reporting_period>0?obj.reporting_number === this.state.selected_reporting_period:true;
                      let status_filter = obj.rp_status===2;
                      return  rp_filter && status_filter;
                    })

                  let projectPerformanceData = JSON.parse(JSON.stringify(result.rps))
                  this.setDownloadInfo(projectPerformanceData)
                  resolve({
                    data: result.rps,
                    page: 0,
                    totalCount: result.rps.length,
                  })
                })
                .catch(err => {resolve({data:[], page: 0, totalCount:0})})
            }) 
          }
          />
















        




         <MaterialTable
            tableRef={this.tableRef}
            onRowClick={((evt, selectedRow) => this.setState({ selectedRow }))}
            style={{minWidth:"100% !important"}}
            options={{
              actionsColumnIndex:7,
              paging:false,
              search:false,
              sorting:false,
              maxBodyHeight:"300px",
              headerStyle: {
                backgroundColor: '#FFF',
                color: '#000',
                fontSize:'1.05em'
              },
              rowStyle: (rowData) => {
                  return {
                  backgroundColor: 
                      (this.state.selectedRow && this.state.selectedRow.tableData.id === rowData.tableData.id) ? 
                      '#EEE' 
                      :(rowData.tableData.id%2)?"#fff":"#f9f9fa"
                  }
              }
            }}
            actions={[
              {
                icon: 'save',
                tooltip: 'Save Data',
                isFreeAction: true,
                onClick: () => 
                {
                  this.childref1.downloadData() 
                }
              }
            ]}
            title="Project Earned Schedule"
            columns={[
              { 
                title: 'RP', 
                field: 'reporting_number',
                cellStyle: {
                  borderRight: "1px solid #d4d4d4"
                }
              },
              { 
                title: 'ES', 
                field: 'calc_es',
                cellStyle: {
                  borderRight: "1px solid #d4d4d4"
                }
              },
              { 
                title: 'SVt', 
                field: 'calc_svt',
                cellStyle: {
                  borderRight: "1px solid #d4d4d4"
                }
              },
              { 
                title: 'SPIt', 
                field: 'calc_spit',
                cellStyle: {
                  borderRight: "1px solid #d4d4d4"
                }
              },
              { 
                title: 'EACt', 
                field: 'calc_eact',
                cellStyle: {
                  borderRight: "1px solid #d4d4d4"
                }
              },
              { 
                title: 'EACt (date)', 
                field: 'calc_end_date',
                cellStyle: {
                  borderRight: "1px solid #d4d4d4"
                }
              },
            ]}
          data={query =>
            new Promise((resolve, reject) => {
              let url =SERVER_PATH + '/projects/CaInRps/' + this.props.project;
              fetch(url,AXIOS_CONFIG())
                .then(response => response.json())
                .then(result => {
                  // let formatter = null;
                  // if (typeof Intl === 'object' && typeof Intl.NumberFormat === 'function') 
                  // {
                  //   formatter = new Intl.NumberFormat('gt-GT', {
                  //     minimumFractionDigits: 2,
                  //   });
                  // }
                  let reporting_number = 1; //Primer reporting number siempre!
                  let rp_status = 1; //Estado del rp
                  let temp_result = [];
                  let planned_value = 0;
                  let earned_value = 0;
                  let actual_cost = 0;
                  let number_days = 0;
                  let end_date;
                  let start_date;
                  let rp_type = 1;
                  result.rps.map(o => {
                    if(o.reporting_number !== reporting_number)
                    {
                      temp_result.push({
                        reporting_number:reporting_number,
                        planned_value:planned_value,
                        earned_value:earned_value,
                        actual_cost:actual_cost,
                        rp_status:rp_status,
                        number_days:number_days ,
                        end_date:end_date,
                        start_date:start_date,
                        rp_type:rp_type,
                      });
                      //SE COMENTO DEBIDO A QUE SON LOS CUMULATIVE LOS QUE SE QUIEREN...POR LO QUE AHORA YA NO SE REINICIAN A 0
                      // actual_cost       =0;
                      // planned_value     =0;
                      // earned_value      =0;
                      reporting_number  =o.reporting_number;
                      rp_type = o.type;
                    }
                    // if(this.state.selected_control_account > 0 && o.control_account !== this.state.selected_control_account)
                    if(false)
                    {
                      //DO NOTHING
                    }else{
                      //Filtrando
                      actual_cost += o.actual_cost;
                      planned_value += o.planned_value;
                      earned_value += o.earned_value;
                    }
                    rp_status = o.rp_status;
                    end_date = o.end_date;
                    start_date = o.start_date;
                    let start = moment(o.start_date); //todays date
                    let end = moment(o.end_date); // another date
                    let duration = moment.duration(end.diff(start));
                    number_days = duration.asDays();
                    return o;
                  });
                  //Ultimo push
                  temp_result.push({
                    reporting_number:reporting_number,
                    planned_value:planned_value,
                    earned_value:earned_value,
                    actual_cost:actual_cost,
                    rp_status:rp_status,
                    number_days:number_days,
                    end_date:end_date,
                    rp_type:rp_type
                  });
                  
                  result.rps = temp_result;

                  // let last_reporting_number = result.rps[result.rps.length - 1].reporting_number;
                  let PD = -1;
                  let total_days = 0;
                  const last_rp_number = result.rps[result.rps.length - 1].reporting_number;
                  const first_start_date =  moment(result.rps[0].start_date);
                  const last_end_date = moment(result.rps[result.rps.length-1].end_date);
                  total_days = last_end_date.diff(first_start_date, 'days');
                  const last_pv = result.rps[result.rps.length - 1].planned_value;
                  result.rps.map(rp=>{
                    if (rp.rp_type ===1)
                    {
                      PD = rp.reporting_number;
                     
                    }
                    //  total_days+= rp.number_days;
                    return rp;
                  });



                  for (let i=0; i< result.rps.length; i++)
                  {
                    let rp = result.rps[i];
                    let es_bueno = 0;
                    let es_ahead = rp.earned_value> rp.planned_value;



                    if (i === result.rps.length - 1)
                    {
                      //Si es el ulimo rp
                      if(result.rps.length > 1)
                      {
                        //Comparar el penultimo rp
                        let penultimo_rp =  result.rps[i-1];
                        es_ahead = penultimo_rp.earned_value > penultimo_rp.planned_value;
                      }
                    }

                    if(es_ahead)
                    {

                      //AHEAD OF SCHEDULE
                      if (i < result.rps.length -1)
                      {
                        let rp1 = result.rps[i+1];
                        let temp1 = (rp.earned_value - rp.planned_value);
                        let temp2 = (rp1.planned_value - rp.planned_value);
                        es_bueno = rp.reporting_number + (temp1/ temp2);
                        
                      }else
                      { 
                        let temp1 = (rp.earned_value - rp.planned_value);
                        let temp2 = (0- rp.planned_value);
                        es_bueno = rp.reporting_number + (temp1/ temp2);
                      }

                    }
                    else
                    {
                      //BEHIND OF SCHEDULE
                      let pv_1 = 0;//PVn-1
                      if(i>0)
                      {
                        let rp1 = result.rps[i-1];//rp de n-1
                        pv_1 = rp1.planned_value; //planned value de n-1
                      }
                      if(rp.planned_value === rp.earned_value && i===result.rps.length-1)
                      {
                        //APLICANDO NOTAS DE BEHIND
                        if(rp.reporting_number > PD)
                          es_bueno = PD; //SI ES BEHIND 
                        else
                        {
                          //FORMULA 1 PORQUE ES on SCHEDULE  FROM BEHIND 
                          let temp1 = (rp.earned_value - pv_1);
                          let temp2 = (rp.planned_value - pv_1);
                          es_bueno = (rp.reporting_number - 1) + (temp1/ temp2);
                        }
                      }
                      else if(i<2 ||(pv_1<=rp.earned_value && rp.earned_value< rp.planned_value))
                      {
                        //FORMULA 1
                        let temp1 = (rp.earned_value - pv_1);
                        let temp2 = (rp.planned_value - pv_1);
                        es_bueno = (rp.reporting_number - 1) + (temp1/ temp2);
                      }
                      else
                      {
                        let rp2 = result.rps[i-2];//rp de n-2
                        let pv_2 = rp2.planned_value; //planned value de n-2
                        let temp1 = (rp.earned_value - pv_2);
                        let temp2 = (rp.planned_value - pv_2);
                        es_bueno = (rp.reporting_number - 1) + (temp1/ temp2);
                      }
                      

                    }


                    rp.calc_es = es_bueno.toFixed(2);
                    //se cambio el svt a es - rp
                    // rp.calc_svt = rp.reporting_number - rp.calc_es;
                    rp.calc_svt = rp.calc_es - rp.reporting_number;
                    rp.calc_svt = rp.calc_svt.toFixed(2);
                    rp.calc_spit = rp.calc_es / rp.reporting_number;
                    rp.calc_spit = rp.calc_spit.toFixed(2);
                    rp.calc_eact = PD / rp.calc_spit;
                    rp.calc_eact = rp.calc_eact.toFixed(2);


                    let finalizo_proyecto = false;
                    if(rp.earned_value === last_pv)
                    {
                      finalizo_proyecto = true;
                    }

                    //calculo de EACt Date
                    let proporcion =  rp.calc_eact / last_rp_number;
                    let dias_calculados = proporcion * total_days;
                    const first_date_clone = first_start_date.clone();
                    rp.calc_end_date= first_date_clone.add("days", dias_calculados).format("YYYY-MM-DD");

                    
                    rp.calc_es = isNaN(rp.calc_es) || !isFinite(rp.calc_es)?"-":rp.calc_es;
                    rp.calc_svt = isNaN(rp.calc_svt) || !isFinite(rp.calc_svt)?"-":rp.calc_svt;
                    rp.calc_spit = isNaN(rp.calc_spit) || !isFinite(rp.calc_spit)?"-":rp.calc_spit;
                    rp.calc_eact = isNaN(rp.calc_eact) || !isFinite(rp.calc_eact)?"-":rp.calc_eact;
                    if(finalizo_proyecto)
                    {
                      break;
                    }
                  }



                   result.rps = result.rps.filter(obj => {
                      //Filtrando por reporting_number y el estado sea completado
                      // let rp_filter = this.state.selected_reporting_period>0?obj.reporting_number === this.state.selected_reporting_period:true;
                      let status_filter = obj.rp_status===2;
                      return   status_filter; //&& rp_filter 
                  })

                  let projectPerformanceData = JSON.parse(JSON.stringify(result.rps))
                  this.setDownloadInfo1(projectPerformanceData)
                  resolve({
                    data: result.rps,
                    page: 0,
                    totalCount: result.rps.length,
                  })
                })
                .catch(err => {resolve({data:[], page: 0, totalCount:0})})
            }) 
          }
          />
          <DownloadCsv 
            style={{display:"none !important"}} 
            visible={true}
            innerRef={node => this.childref = node}
            tableData={this.state.tableData}
            ocultar={true}
        />
        <DownloadCsv 
            style={{display:"none !important"}} 
            visible={true}
            innerRef={node => this.childref1 = node}
            tableData={this.state.tableData1}
            ocultar={true}
        />
        </div>
      )
    }
}


/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    status: state.status,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Status);



// WEBPACK FOOTER //
// ./src/features/status/Status.js